import { configValue } from "@/services/config";

export type AppEnvironment = ApplicationConfiguration["VUE_APP_ENVIRONMENT"];

const environmentConfig = {
  local: {
    label: "Development environment",
    titlePrefix: "[DEV]",
    backgroundColor: "#a7f3d0",
  },
  test: {
    label: "Test environment",
    titlePrefix: "[TEST]",
    backgroundColor: "#c7d2fe",
  },
  stage: {
    label: "Staging environment",
    titlePrefix: "[STAGE]",
    backgroundColor: "#fed7aa",
  },
} as const satisfies Record<
  Exclude<AppEnvironment, "prod">,
  { label: string; titlePrefix: string; backgroundColor: string }
>;

function getAppEnvironment(): AppEnvironment {
  return configValue("VUE_APP_ENVIRONMENT");
}

export function getEnvironmentBanner() {
  const environment = getAppEnvironment();
  if (environment === "prod") {
    return null;
  }
  return environmentConfig[environment];
}

export function getEnvironmentTitlePrefix(): string {
  return getEnvironmentBanner()?.titlePrefix ?? "";
}
